import { visT } from "views/components/visualizations/visualizationTranslation";
import SankeyVisualization from "views/components/visualizations/sankey/SankeyVisualization";
const countGroupingFields = (formValues) => {
  var _a, _b;
  return ((_b = (_a = formValues.groupBy) == null ? void 0 : _a.groupings) != null ? _b : []).reduce((total, grouping) => {
    var _a2, _b2;
    return total + ((_b2 = (_a2 = grouping.fields) == null ? void 0 : _a2.length) != null ? _b2 : 0);
  }, 0);
};
const validate = (formValues) => {
  var _a, _b;
  if (countGroupingFields(formValues) < 2) {
    return { type: visT("vis_validation.sankey_requires_groupings") };
  }
  if (((_b = (_a = formValues.metrics) == null ? void 0 : _a.length) != null ? _b : 0) > 1) {
    return { type: visT("vis_validation.sankey_single_metric") };
  }
  return {};
};
const sankey = {
  type: SankeyVisualization.type,
  get displayName() {
    return visT("vis_types.sankey");
  },
  component: SankeyVisualization,
  validate
};
export default sankey;
